<h2>Filtrar Controles</h2>
<div class="redil-info">
	<div class="body">
		<section>
			<div class="info">
				<div class="info-row">
					<label for="input-id">Código control</label>
					<input
						id="input-id"
						class="ui-inputtext"
						type="text"
						[(ngModel)]="filters.code"
						placeholder="Id Control"
						pInputText
					/>
				</div>

				<div class="info-row">
					<label for="input-control">Ganadería</label>
					<p-multiSelect
						defaultLabel="Ganadería"
						maxSelectedLabels="2"
						selectedItemsLabel="{0} Seleccionados"
						[options]="farms"
						[(ngModel)]="filters.farm"
						optionLabel="name"
					>
					</p-multiSelect>
				</div>

				<div class="info-row">
					<label for="input-control">Método de ordeño</label>
					<p-multiSelect
						defaultLabel="Método de ordeño"
						maxSelectedLabels="2"
						selectedItemsLabel="{0} Seleccionados"
						[options]="methods"
						[(ngModel)]="filters.method"
						optionLabel="name"
					>
					</p-multiSelect>
				</div>

				<div class="info-row">
					<label for="input-control">Controlador</label>
					<p-multiSelect
						defaultLabel="Controlador"
						maxSelectedLabels="2"
						selectedItemsLabel="{0} Seleccionados"
						[options]="controllers"
						[(ngModel)]="filters.controller"
						optionLabel="name"
					>
					</p-multiSelect>
				</div>

				<div class="info-row">
					<label for="input-id" class="date-label">Nº de alertas</label>
					<p class="date-interval">Mayor o igual:</p>
					<input
						id="input-id"
						class="ui-inputtext alert-counts"
						type="number"
						[(ngModel)]="filters.alertCount.start"
						placeholder="0"
						pInputText
					/>
					<p class="date-interval">Menor o igual:</p>
					<input
						id="input-id"
						class="ui-inputtext alert-counts"
						type="number"
						[(ngModel)]="filters.alertCount.end"
						placeholder="0"
						pInputText
					/>
				</div>

				<div class="info-row">
					<label for="control-date" class="date-label">Fecha de control</label>
					<p class="date-interval">Desde:</p>
					<p-calendar
						id="control-date"
						appUseUtc
						[(ngModel)]="filters.date.start"
						[locale]="es.calendar_es"
						dateFormat="dd/mm/yy"
						[showIcon]="true"
						[appendTo]="'body'"
						[placeholder]="'24/06/1998'"
					></p-calendar>
					<p class="date-interval">Hasta:</p>
					<p-calendar
						id="control-date"
						appUseUtc
						[(ngModel)]="filters.date.end"
						[locale]="es.calendar_es"
						dateFormat="dd/mm/yy"
						[showIcon]="true"
						[appendTo]="'body'"
						[placeholder]="'24/06/1998'"
					>
					</p-calendar>
				</div>
			</div>
		</section>
		<div></div>
		<div class="centered">
			<button (click)="onSaveFilters()" class="app-btn orange">Guardar Filtros</button>
			<button (click)="onClearFilters()" class="app-btn primary">Borrar Filtros</button>
		</div>
	</div>
</div>
